import { apiTransport as router } from './transport';
import type { QueryFilters } from './transport';
import { getContext } from './core';
import { Job, JobConfig } from '@repo/shared-types';

export const jobsApi = {
  schedule: async (config: JobConfig) => {
    const context = getContext();
    return router.post<Job>('/jobs/schedule', config, context);
  },
  list: async (filters?: QueryFilters) => {
    return router.get<Job[]>('/jobs', undefined, filters);
  },
  get: async (id: string) => {
    return router.get<Job>(`/jobs/${id}`);
  },
  cancel: async (id: string) => {
    const context = getContext();
    return router.post<{ success: boolean }>(`/jobs/${id}/cancel`, {}, context);
  }
};

